module.exports = __webpack_public_path__ + "img/auth0.109d4c73.svg";